import { Resource_AppointmentTaskStatus } from '@/generated/graphql';

export const AppointmentTaskStatusColors = new Map<Resource_AppointmentTaskStatus, string>([
  [Resource_AppointmentTaskStatus.AppointmentTaskStatusCreated, '#5f5f5f'],
  [Resource_AppointmentTaskStatus.AppointmentTaskStatusFinished, 'darkgreen'],
  [Resource_AppointmentTaskStatus.AppointmentTaskStatusCanceled, 'darkred'],
  [Resource_AppointmentTaskStatus.AppointmentTaskStatusNotYetCreated, 'orange'],
  [Resource_AppointmentTaskStatus.AppointmentTaskStatusStarted, '#386a96'],
  [Resource_AppointmentTaskStatus.AppointmentTaskStatusResolvedUnavailable, '#8c6d1f'],
]);
